import { APICore } from "./apiCore";

const api = new APICore()

function getRoles(params: any): any {
    const baseUrl = "/roles"
    return api.get(baseUrl, params)
}

function getRole(id: String): any {
    const baseUrl = `/roles/${id}`
    return api.get(baseUrl, {})
}

function getRoleTopbar(id: String): any {
    const baseUrl = `/roles/${id}`
    return api.get(baseUrl, {})
}

function addRole(params: any): any {
    const baseUrl = "/roles"
    return api.create(baseUrl, params)
}
function updateRole(params: any): any {
    const baseUrl = "/roles"
    return api.update(baseUrl, params)
}
function deleteRole(params: any): any {
    const baseUrl = "/roles"
    return api.delete(baseUrl, params)
}

export { getRoles, getRole, getRoleTopbar, addRole, updateRole, deleteRole }